import { render, staticRenderFns } from "./IconAdd.vue?vue&type=template&id=85193d0a&"
import script from "./IconAdd.vue?vue&type=script&lang=ts&"
export * from "./IconAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports